/**
 * Filters a recursive tree dictionary.
 *
 * @example
 *   const input = [
 *     {
 *       label: 'a',
 *       items: [
 *         {
 *           label: 'b',
 *           items: [{ label: '' }],
 *         },
 *         { label: 'c' },
 *       ],
 *     },
 *     {
 *       label: '',
 *       items: [{ label: 'y' }],
 *     },
 *   ];
 *
 *   treeFilter(input, (item) => item.label !== '', 'items');
 *
 *   const output = [
 *     {
 *       label: 'a',
 *       items: [
 *         {
 *           label: 'b',
 *           items: [],
 *         },
 *         { label: 'c' },
 *       ],
 *     },
 *   ];
 *
 * @param items The tree of items.
 * @param predicateFn The predicate filter function.
 * @param childrenKey The key used to store the nested items.
 */
export function treeFilter(items, predicateFn, childrenKey) {
    return items.filter(predicateFn).map((item) => {
        if (childrenKey in item) {
            return Object.assign(Object.assign({}, item), { [childrenKey]: treeFilter(item[childrenKey], predicateFn, childrenKey) });
        }
        return item;
    });
}
